/** Local imports */

import {reducer as user} from '~/common/fabric/User/reducers/user';
import {reducer as cachedMedia} from '~/common/reducers/cachedMedia';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {reducer as favorites} from './favorites';
import {reducer as filters} from './filters';
import {reducer as galleryData} from './galleryData';

export const rootReducer = {
  galleryData,
  favorites,
  filters,
  cachedMedia,
  loginModal,
  user,
};
